import { useAtomValue } from "jotai"
import { useTranslation } from "react-i18next"
import { metadataFailureCountAtom, metadataIndexingProgressAtom } from "@/store/app-state"
import { Button } from "../ui/Button"
import { Dialog } from "../ui/Dialog"
import { ProgressBar } from "../ui/ProgressBar"

export const MetadataProgressDialog = ({ onCancel }: { onCancel: () => void }) => {
	const { t } = useTranslation("components")
	const progress = useAtomValue(metadataIndexingProgressAtom)
	const failures = useAtomValue(metadataFailureCountAtom)
	const completed = progress?.completed ?? 0
	const total = progress?.total ?? 0
	const percent = total > 0 ? Math.floor((completed / total) * 100) : 0
	const title = t("metadataProgressDialog.title")

	return (
		<Dialog trackingViewName="metadata_progress_dialog" disableClose>
			<div className="flex w-[462px] flex-col space-y-4">
				<div className="text-md font-bold">{title}</div>
				<div className="text-sm text-base-300">
					{t("metadataProgressDialog.description")}
				</div>
				<div className="flex flex-col space-y-2">
					<div className="flex justify-between text-xs text-base-400">
						<span>{t("metadataProgressDialog.counter", { completed, total })}</span>
						<span>{percent}%</span>
					</div>
					<ProgressBar max={100} value={percent} aria-label={title} />
				</div>
				{failures > 0 && (
					<div className="text-xs text-base-400" role="status">
						{t("metadataProgressDialog.failed", { count: failures })}
					</div>
				)}
				<div className="flex justify-end">
					<Button trackingLabel="cancel_metadata_indexing" onClick={onCancel}>
						{t("common:action.cancel")}
					</Button>
				</div>
			</div>
		</Dialog>
	)
}
